<template>
  <HeatmapReport class="maxh-1bar" :fetcher="this" />
</template>

<script>
import HeatmapReport from '../../../components/heatmap/HeatmapReport.vue'
import { Tracker } from '@/models'

export default {
  tabTitle: 'Heatmap',
  tabGroup: 'Veículo',
  components: {
    HeatmapReport
  },
  props: {
    value: { required: true }
  },
  computed: {
    syntheticVid() {
      return this.value.organizationId * 10000 + this.value.vehicleId
    }
  },
  methods: {
    fetchStats() {
      return Tracker.findStats({ syntheticVid: this.syntheticVid })
    },

    fetchPositions(apiParams) {
      return Tracker.findAggregate(this.syntheticVid, apiParams)
    }
  }
}
</script>

<style></style>
